import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class RoleService extends RestfulService<Models.Role> {

  constructor(private restService: RestService) {
    super(Models.Role);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('roles');
  }

}
